/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import { getJMessageAuth } from "@/api/user";
import store from "@/store/index";

export default {
  namespaced: true,
  state: {
    // 整个IM的会话列表，包括聊天内容
    conversations: [],
    // 消息页面到会话列表
    conversationList: []
  },
  getters: {},
  mutations: {
    SET_MESSAGES(state, data) {
      state.conversations = data;
    },
    SEND_MESSAGE(state, { data, msg, fromUsername }) {
      const newConversations = JSON.parse(JSON.stringify(state.conversations));
      // 如果不存在这个会话
      const isNewConversation = newConversations.some(
        ({ from_username }) => from_username === fromUsername
      );
      if (isNewConversation) {
        console.log("旧会话");
        for (let conversation of newConversations) {
          if (conversation.from_username === fromUsername) {
            conversation.msgs.push(msg);
          }
        }
      } else {
        console.log("新会话");
        const newConversation = {
          from_appkey: data.appkey,
          from_username: data.target_username,
          key: data.key,
          msgs: [msg]
        };
        newConversations.push(newConversation);
      }
      state.conversations = newConversations;
    },
    RECEIVE_MESSAGE(state, message) {
      const newConversations = JSON.parse(JSON.stringify(state.conversations));
      // 如果不存在这个会话
      const isNewConversation = newConversations.some(
        ({ from_username }) => from_username === message.from_username
      );
      if (isNewConversation) {
        console.log("旧会话");
        for (let conversation of newConversations) {
          if (conversation.from_username === message.from_username) {
            conversation.msgs.push(message);
          }
        }
      } else {
        console.log("新会话");
        const newConversation = {
          from_appkey: message.from_appkey,
          from_username: message.from_username,
          msgs: [message]
        };
        newConversations.push(newConversation);
      }
      state.conversations = newConversations;
    },
    SET_CONVERSATION_LIST(state, data) {
      state.conversationList = data.reverse();
    }
  },
  actions: {
    async chatInit({ dispatch }) {
      return new Promise((resolve, reject) => {
        getJMessageAuth().then(
          ({ appkey, random_str, signature, timestamp }) => {
            window.JIM = new JMessage({
              debug: false
            });
            JIM.init({
              appkey,
              random_str,
              signature,
              timestamp,
              flag: 1
            })
              .onSuccess(async function(data) {
                console.log("初始化成功：" + JSON.stringify(data, null, 4));
                const result = await dispatch("isRegister");
                if (!result) {
                  await dispatch("register");
                  await dispatch("login");
                }
                resolve();
              })
              .onFail(function(data) {
                console.log("初始化失败:" + JSON.stringify(data, null, 4));
                reject();
              });
          }
        );
      });
    },
    register(
      { commit, dispatch },
      { username, password, nickname } = {
        username: store.state.user.phone,
        password: store.state.user.phone,
        nickname: store.state.user.nickname
      }
    ) {
      return new Promise((resolve, reject) => {
        JIM.register({
          username,
          password,
          nickname
        })
          .onSuccess(function(data) {
            console.log("注册成功:" + JSON.stringify(data, null, 4));
            resolve();
          })
          .onFail(function(data) {
            reject();
            console.log("注册失败:" + JSON.stringify(data, null, 4));
          });
      });
    },
    sendSingleMsg({ commit }, { targetUsername, content }) {
      return new Promise((resolve, reject) => {
        JIM.sendSingleMsg({
          target_username: targetUsername,
          content
        })
          .onSuccess(function(data, msg) {
            commit("SEND_MESSAGE", {
              data,
              msg,
              fromUsername: targetUsername
            });
            resolve();
          })
          .onFail(function(data) {
            reject(data);
          });
      });
    },
    sendSinglePic({ commit, dispatch }, { targetUsername, file }) {
      return new Promise((resolve, reject) => {
        JIM.sendSinglePic({
          target_username: targetUsername,
          image: file
        })
          .onSuccess(async function(data, msg) {
            const result = await dispatch(
              "getResource",
              msg.content.msg_body.media_id
            );
            commit("SEND_MESSAGE", {
              msg,
              fromUsername: targetUsername
            });
            resolve();
          })
          .onFail(function(data) {
            reject(data);
          });
      });
    },
    getResource({ commit }, id) {
      return new Promise((resolve, reject) => {
        JIM.getResource({ media_id: id })
          .onSuccess(function(data) {
            resolve(data);
          })
          .onFail(function(data) {
            reject(data);
          });
      });
    },
    isRegister({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        JIM.login({
          username: store.state.user.phone,
          password: store.state.user.phone
        })
          .onSuccess(async function(data) {
            console.log("直接登录成功");
            dispatch("getSyncConversation");
            await dispatch("getConversation");
            resolve(true);
            console.log("直接登录成功结束");
            //  接受消息
            dispatch("onMsgReceive");
          })
          .onFail(function(data) {
            // 用户不存在
            if (data.code === 880103) {
              resolve(false);
            }
          })
          .onTimeout(function(data) {
            console.log("登录超时:" + JSON.stringify(data, null, 4));
            reject();
          });
      });
    },
    getSyncConversation({ commit }) {
      return new Promise(resolve => {
        JIM.onSyncConversation(function(conversations) {
          //离线消息同步监conversation听
          commit("SET_MESSAGES", conversations);
          resolve();
          console.log("离线消息", conversations);
        });
      });
    },
    login({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        JIM.login({
          username: store.state.user.phone,
          password: store.state.user.phone
        })
          .onSuccess(async function(data) {
            console.log("先注册，再登录成功");
            // const result = await dispatch("getSyncConversation");
            await dispatch("getConversation");
            resolve();
          })
          .onFail(function(data) {
            console.log("登录失败:" + JSON.stringify(data, null, 4));
            // 用户不存在
            if (data.code === 880103) {
              dispatch("register");
            }
          })
          .onTimeout(function(data) {
            console.log("登录超时:" + JSON.stringify(data, null, 4));
            reject(data);
          });
      });
    },
    getUserInfo({ commit }, username) {
      return new Promise((resolve, reject) => {
        JIM.getUserInfo({
          username
        })
          .onSuccess(function(data) {
            resolve(data);
          })
          .onFail(function(data) {
            reject(data);
          });
      });
    },
    getConversation({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        JIM.getConversation()
          .onSuccess(function({ conversations }) {
            console.log("获取了会话列表", conversations);
            Promise.all(
              conversations.map(async conversation => {
                if (conversation.avatar) {
                  const { url } = await dispatch(
                    "getResource",
                    conversation.avatar
                  );
                  conversation.avatar = url;
                  return conversation;
                } else {
                  return conversation;
                }
              })
            ).then(() => {
              console.log(conversations);
              commit("SET_CONVERSATION_LIST", conversations);
              resolve();
            });
          })
          .onFail(function(data) {
            reject(data);
          });
      });
    },
    onMsgReceive({ commit, dispatch }) {
      JIM.onMsgReceive(async ({ messages }) => {
        dispatch("getConversation");
        for (const message of messages) {
          commit("RECEIVE_MESSAGE", messages[0]);
        }
      });
    },
    updateSelfInfo({ commit }, nickname) {
      return new Promise((resolve, reject) => {
        JIM.updateSelfInfo({
          nickname
        })
          .onSuccess(function(data) {
            resolve(data);
          })
          .onFail(function(data) {
            reject(data);
          });
      });
    },
    updateSelfAvatar({ commit }, file) {
      return new Promise((resolve, reject) => {
        JIM.updateSelfAvatar({
          avatar: file
        })
          .onSuccess(function(data) {
            resolve(data);
          })
          .onFail(function(data) {
            reject(data);
          });
      });
    }
  }
};
